export default ["LocaleService",function i18n(LocaleService) {
  return function (input, args) {
    return LocaleService.getString(input, args);
  };
}];



// WEBPACK FOOTER //
// ./src/ui/app/filter/i18n.js